export function isSupportLogin(): boolean {
    return localStorage.getItem('support_login')?.toLowerCase() === 'true'
}
